<template>
	<div class="courseDetail bg-[#F5F7FA]">
		<Header></Header>
		<div class="courseInfo mb-[95px]">
			<div class="2xl:w-[1140px] xl:w-[1140px] lg:container md:container mx-auto pt-[20px] ">
				<div class="text-[16px] text-[#000000] mb-[25px]">
					<label class="cursor-pointer mr-[5px]" @click="goIndex()">{{langInfo.head_home_nav}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.course_class}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.head_class_nav}}</label>><label
						class="ml-[5px]">{{productDetail.name}}</label>
				</div>
				<div class="bg-white mb-[14px] shadow-02 rounded-[12px] py-[21px] px-[20px] box-border flex ">
					<el-image class="w-[375px] h-[250px] mr-[15px] rounded-[6px]" :src="productDetail.cover_img"
						fit="cover"></el-image>
					<div class="flex-1">
						<div class="text-[20px] text-[#101010] font-semibold mb-[10px]">
							{{productDetail.name}}
						</div>
						<div class="mb-[15px]">
							<label class="text-[#FF0000] text-[16px] mr-[4px]">{{langInfo.product_price}}</label>
							<label class="text-[#FF0000] text-[16px] mr-[4px]">¥</label>
							<label
								class="text-[#FF0000] text-[26px] mr-[10px]">{{productDetail.course_discount}}</label>
							<label
								class="text-[#7A7A7A] text-[16px]">{{langInfo.original_price}}¥{{productDetail.course_original}}</label>
						</div>

						<div class="flex items-start text-[16px] text-[#101010] mb-[10px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon18.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.related_courses}}
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in course_list" :key="index">
									{{item.course_name}}<label v-if="index<course_list.length - 1">、</label>
								</div>
							</div>
						</div>
						<div class="flex items-start text-[16px] text-[#101010] mb-[14px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon19.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.associated_certificate}}
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in certificate_list" :key="index">
									{{item.name}}<label v-if="index<certificate_list.length - 1">、</label>
								</div>
							</div>
						</div>
						<div class="flex items-start text-[16px] text-[#101010] mb-[37px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon20.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.validity_period}}
							</div>
							<div class="flex-1">
								{{productDetail.period_of_validity}}{{langInfo.day}}
							</div>
						</div>
						<div class="flex items-center justify-between">
							<div class="flex items-center text-[14px] text-[#FF0000]">
								<img src="@/static/image/icon21.png" class="w-[20px] h-[20px] mr-[10px]" alt="" />
								{{productDetail.study_count}}{{langInfo.people_learning}}
							</div>
							<div class="flex items-center">
								<div @click="buy_now_btn()"
									class="min-w-[134px] h-[36px] cursor-pointer px-[10px] box-border mr-[19px] bg-[#2979FF] rounded-[50px] text-white text-[16px] text-center leading-[36px]">
									{{langInfo.buy_now}}
								</div>
								<div @click="addCart()"
									class="w-[134px] h-[36px] cursor-pointer  mr-[26px] border border-[#2979FF] border-solid rounded-[50px] text-[#2979FF] text-[16px] text-center leading-[36px]">
									{{langInfo.add_cart}}
								</div>
								<div @click="collectClick()"
									class="flex items-center cursor-pointer text-[#101010] text-[16px] mr-[12px]">
									<img v-if="productDetail.is_l2==1" src="@/static/image/icon22Active.png"
										class="w-[24px] h-[24px] mr-[6px]" alt="" />
									<img v-else src="@/static/image/icon22.png" class="w-[24px] h-[24px] mr-[6px]"
										alt="" />
									{{productDetail.is_l2==1?langInfo.collected:langInfo.study_collect}}
								</div>
								<!-- <el-popover placement="bottom" trigger="hover">
									<div class="">
										<div @click="shareQQ()"
											class="cursor-pointer flex items-center pb-[10px] box-border bB-04">
											<img src="@/static/image/icon78.png" class="w-[20px] h-[20px] mr-[10px]"
												alt="" srcset="" /> {{langInfo['Share_QQ']}}
										</div>
										<div @click="shareWB()"
											class="cursor-pointer flex items-center pt-[10px] box-border">
											<img src="@/static/image/icon79.png" class="w-[20px] h-[20px] mr-[10px]"
												alt="" srcset="" />
											{{langInfo['Share_Weibo']}}
										</div>
									</div>
									<div slot="reference"
										class="flex items-center cursor-pointer text-[#101010] text-[16px]">
										<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]"
											alt="" />
										{{langInfo.share}}
									</div>
								</el-popover> -->

								<div @click.stop="copyClick()"
									class="flex items-center cursor-pointer text-[#101010] text-[16px]">
									<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]" alt="" />
									{{langInfo.share}}
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="flex">
					<div
						class="2xl:w-[845px] xl:w-[845px] h-[729px] lg:w-[720px] md:w-[600px] rounded-[12px] pb-[16px] box-border bg-white mr-[22px] flex flex-col">
						<div class="pt-[26px] pb-[16px] px-[20px] box-border border-01 flex items-center">

							<div @click="type=2" :class="type==2?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer text-[16px]  relative mr-[60px]">
								{{langInfo.related_courses}}
							</div>
							<div @click="type=1" :class="type==1?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer  relative text-[16px] ">
								{{langInfo.details_text_images}}
							</div>

						</div>
						<div class="p-5 box-border flex-1" style="overflow-y: scroll;">
							<!-- 图文详情 -->
							<div class="text-[14px] text-[#101010]" v-if="type==1">
								<div class="" v-if="isFinish&&productDetail.description"
									v-html="productDetail.description" class="whitespace-pre-wrap">
								</div>
								<emptyPage v-else-if="isFinish&&!productDetail.description"
									:title="langInfo.no_brief_info">
								</emptyPage>
							</div>
							<!-- 图文详情 -->
							<!-- 关联课程 -->
							<div class="" v-else-if="type==2">
								<router-link :to="{path:'/courseChild',query: { id: item.id }}"
									v-for="(item,index) in course_list" :key="index"
									class="no-underline bg-[#F7F9FC] mb-[12px] rounded-[5px] py-[20px] px-[16px] box-border flex justify-between">
									<el-image class="w-[225px] h-[150px] mr-[14px] rounded-[6px]"
										:src="item.course_logo" fit="cover"></el-image>
									<div class="flex-1 min-h-[150px] flex flex-col justify-between">
										<div class="">
											<div class="text-[16px] text-[#000000] yw-text-cut-1 mb-[9px]">
												{{item.course_name}}
											</div>
											<div class="flex  " v-if="item.certificate_list.length>0">
												<img src="@/static/image/icon25.png"
													class="w-[15px] h-[15px] mr-[10px]" />
												<div class="flex-1 text-[14px] flex flex-wrap text-[#A2A2A2]">
													<label class="mb-[10px] " v-for="(ite,ind) in item.certificate_list"
														:key="ind">
														{{ite.name}}<label
															v-if="ind<item.certificate_list.length - 1">、</label>
													</label>
												</div>
											</div>
											<div class="flex  mb-[8px]" v-if="item.subject_list.length>0">
												<img src="@/static/image/icon26.png"
													class="w-[15px] h-[15px] mr-[10px]" />
												<div class="flex-1 text-[14px] text-[#A2A2A2]">
													<label class="mb-[10px]" v-for="(ite,ind) in item.subject_list"
														:key="ind">
														{{ite.name}}<label
															v-if="ind<item.subject_list.length - 1">、</label>
													</label>
												</div>
											</div>

										</div>
										<div
											class="bg-white text-[14px]  text-[#101010] text-center w-[80px] h-[30px] leading-[30px] rounded-[4px] border border-[#bbbbbb] border-solid">
											{{langInfo.course_Introduction}}
										</div>
									</div>
								</router-link>

							</div>
							<!-- 关联课程 -->
						</div>
					</div>
					<div class="flex-1">
						<div class="text-[16px] text-[#1C1F21] font-semibold ">
							{{langInfo.recommended_baby}}
						</div>
						<div class="">
							<router-link :to="{path:'/courseDetail',query: { id: item.id }}"
								class="no-underline flex justify-between py-[9px] box-border bB-01"
								v-for="(item,index) in recommend_product" :key="index">
								<el-image class="w-[126px] h-[84px] mr-[14px] rounded-[6px]" :src="item.cover_img"
									fit="cover"></el-image>
								<div class="flex-1 h-[84px] flex justify-between flex-col">
									<div class="yw-text-cut-2 text-[12px] text-[#545C63]">
										{{item.name}}
									</div>
									<div class="text-[12px]">
										<div class="text-[#FF0000]  mb-[4px]">
											¥{{item.course_discount}}
										</div>
										<div class="flex items-center text-[#9199A1]">
											<img src="@/static/image/icon24.png" class="w-[18px] h-[15px] mr-[4px]"
												alt="" srcset="" />
											{{item.sales_volume}}{{langInfo.person_purchases}}
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>

		<!-- 收银台 -->
		<el-dialog :title="langInfo.checkstand" @close="closeDialog" :visible.sync="payVisible"
			:close-on-click-modal="false" width="40%" center top="8vh">
			<div class="bg-white mb-[10px] py-[20px] px-[16px] box-border flex justify-between items-center">
				<div class="flex-1 flex mr-[80px]">
					<el-image class="w-[147px] h-[96px] mr-[16px] rounded-[6px]" :src="productDetail.cover_img"
						fit="cover"></el-image>
					<div class="flex-1 ">
						{{productDetail.name}}
					</div>
				</div>
				<div class="text-[20px] text-[#FF0000]">
					¥{{productDetail.course_discount}}
				</div>
			</div>
			<div class="bg-white mb-[10px]  flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px]  font-bold">
					{{langInfo['Remarks (Optional)']}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.remarks" class="formInput w-full text-[18px]"
						:placeholder="langInfo.enter_remarks_tip"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo.coupon_title}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.couponCode" @change="couponChange" class="formInput w-full text-[18px]"
						:placeholder="langInfo.enter_coupon_tip"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo['Invitation Code']}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.invitationCode" @change="inviteCodeChange"
						class="formInput w-full text-[18px]" :placeholder="langInfo.enter_invitation_tip"></el-input>

				</div>
			</div>
			<div class="bg-white mb-[20px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] flex items-center mr-[50px]">
					<label class="font-bold">{{langInfo['Balance deduction']}}</label> <label
						class="text-[16px] text-[#686C73]">（{{langInfo['account_balance']}}：{{userInfo.money}}）</label>：
				</div>
				<div class="flex-1 flex align-items-center">
					<div class="flex items-center cursor-pointer mr-[40px]" @click="balanceClick(1)">
						{{langInfo.balance_yes}} <img class="w-[22px] h-[22px] ml-[10px] "
							:src="isBalance==1?selectedImg:selectImg" alt="" srcset="" />
					</div>
					<div class="flex items-center cursor-pointer" @click="balanceClick(2)">
						{{langInfo.balance_no}} <img class="w-[22px] h-[22px] ml-[10px]"
							:src="isBalance==2?selectedImg:selectImg" alt="" srcset="" />
					</div>

				</div>
			</div>
			<div class="text-[18px] flex items-center mb-[20px]">
				<label class="font-bold">{{langInfo['Actual amount']}}</label> <label
					class="text-[16px] ml-[18px] text-[#FF0000]">¥{{pay_price}}</label>
			</div>
			<div class="text-[18px] font-bold mb-[14px]">
				{{langInfo['Payment method']}}
			</div>
			<div class="mb-[24px]  flex items-center ">
				<!-- <div @click="payMethod=5" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==5?selectedImg:selectImg" alt=""
						srcset="" />
					<label class="text-[#000C16] text-[16px]">{{langInfo['Offline pay']}}</label>
				</div> -->
				<div @click="payMethod=2" class="flex  items-center cursor-pointer mr-[40px]">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==2?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index08.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
				<div @click="payMethod=1" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==1?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index09.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
			</div>
			<div @click="nextPay()"
				class="w-[250px] h-[44px] cursor-pointer  mx-auto leading-[44px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['Next step']}}
			</div>
		</el-dialog>
		<el-dialog title="微信支付" @close="closeWxDialog" :visible.sync="wxPay" :close-on-click-modal="false" width="40%"
			center top="8vh">
			<div class="w-[250px] h-[250px]   mx-auto  rounded-[4px]  ">
				<img :src="qrcode" class="w-[250px] h-[250px] " alt="" />
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},

		data() {
			return {
				type: 2, //1图文详情  2关联课程
				id: '',
				isFinish: false,
				productDetail: {
					name: '',
					course_original: '',
					course_discount: '',
					study_count: 0,
					description: '',
					period_of_validity: 0,
					is_l2: 0
				},

				// 关联课程
				course_list: [],
				// 关联证书
				certificate_list: [],

				// 推荐宝贝
				recommend_product: [],


				payVisible: false,
				selectImg: require('@/static/image/icon68.png'),
				selectedImg: require('@/static/image/icon69.png'),
				payMethod: 2, //支付类型:1=微信,2=支付宝,4=余额 , 5=线下支付
				langInfo: {},
				orderInfo: {
					order_id: '',
					order_no: '',
					total_amount: ''
				},
				pay_order: {
					id: '',
					order_no: '',
					pay_coupon: '',
					pay_money: '',

					payment_status: '',
					payment_time: '',
					payment_type: '',
					total_amount: '',
				},

				isBalance: 1, //余额抵扣
				payInfo: {
					remarks: '', //备注，
					couponCode: '', //优惠券码
					invitationCode: '', //邀请码
					pay_money: '' //余额抵扣
				},
				pay_price: '0.00', //支付金额
				userInfo: {
					money: ''
				},
				isLogin: true,

				qrcode: '',
				wxPay: false,
				jieguo: null,
				order_id: '',
				isAlipay: false

			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				if (to.query.id) {
					this.id = to.query.id
					this.get_product_detail()
				}

			}
		},
		mounted() {
			clearInterval(this.jieguo)

			this.id = this.$route.query.id

			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			this.get_product_detail()
			this.getUserInfo()
		},
		destroyed() {
			clearInterval(this.jieguo)
			this.jieguo = null
		},

		methods: {
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.isLogin = true
				}).catch((error) => {
					this.isLogin = false
				})

			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goIndex() {
				this.$router.replace({ path: '/' });
			},
			goCourseCenter() {
				this.$router.replace({ path: '/courseCenter' });
			},
			get_product_detail() {
				this.$api.product_detail({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.productDetail = res.data
					this.course_list = res.data.course_list;
					this.certificate_list = res.data.certificate_list;
					this.recommend_product = res.data.recommend_product

					document.title = this.productDetail.name


					this.productDetail.description = res.data.description.replace(/<img/g,
						"<img style='width:100%;height:auto;'")



				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			collectClick() {
				if (!this.isLogin) {
					// this.$message({
					// 	message: this.langInfo['please log in first'],
					// 	type: 'warning'
					// })
					// setTimeout(() => {
					// 	const currentUrl = this.$route.fullPath;
					// 	localStorage.setItem('loginRedirect', currentUrl);
					// 	this.$router.replace({ path: '/login' })
					// }, 800)
					
					
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {
					
					});
					
					
					return
				}


				this.$api.news_resource_like({
					fid: this.id,
					type: 3, //1=资讯,2=资源,3=宝贝
					is_l: 2 //1=点赞,2=收藏
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})
					this.get_product_detail()
				}).catch((error) => {

					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 加入购物车
			addCart() {
				if (!this.isLogin) {
					// this.$message({
					// 	message: this.langInfo['please log in first'],
					// 	type: 'warning'
					// })
					// setTimeout(() => {
					// 	const currentUrl = this.$route.fullPath;
					// 	localStorage.setItem('loginRedirect', currentUrl);
					// 	this.$router.replace({ path: '/login' })
					// }, 800)
					
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {
					
					});
					
					
					
					return
				}
				this.$api.addOrEdit({
					course_product_id: this.id,
					quantity: 1,
					is_cart: 1,
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})

				}).catch((error) => {

					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			closeDialog() {

				if (this.payMethod == 2 && this.isBalance == 2 && this.isAlipay) {
					this.payInfo = {
						remarks: '', //备注，
						couponCode: '', //优惠券码
						invitationCode: '', //邀请码
						pay_money: '' //余额抵扣
					}
					this.payVisible = false

					this.isAlipay = false

					this.$api.order_detail({
						id: this.order_id,
					}).then((res) => {
						this.order_id = ""
						console.log(res.data);
						if (res.data.payment_status == 1) {
							// 已支付
							this.$message({
								message: this.langInfo['Payment successful'],
								type: 'success'
							})
						} else {
							this.$message({
								message: this.langInfo['Payment failed'],
								type: 'success'
							})
						}

					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {
					this.payInfo = {
						remarks: '', //备注，
						couponCode: '', //优惠券码
						invitationCode: '', //邀请码
						pay_money: '' //余额抵扣
					}
					this.payVisible = false
				}

			},
			// 立即购买
			buy_now_btn() {
				if (!this.isLogin) {
					// 	this.$message({
					// 		message: this.langInfo['please log in first'],
					// 		type: 'warning'
					// 	})

					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {

					});

					return
				}
				this.payVisible = true
				this.$api.create_order({
					course_product_id: this.id,
					quantity: 1,
				}).then((res) => {
					console.log("创建订单");
					console.log(res);
					this.orderInfo = res.data

					this.getPayOrderByOrderNo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getPayOrderByOrderNo() {
				this.$api.getPayOrderByOrderNo({
					order_no: this.orderInfo.order_no
				}).then((res) => {
					console.log("根据订单号查询支付订单详情====");
					console.log(res);
					this.order_id = res.data.orders[0].id

					this.pay_order = res.data.pay_order
					this.calculateAmount()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			balanceClick(type) {
				this.isBalance = type
				this.calculateAmount()
			},
			// 计算金额接口
			calculateAmount() {
				this.$api.calculateAmount({
					pay_order_id: this.orderInfo.pay_order_id,
					is_pay_money: this.isBalance,
					coupon: this.payInfo.couponCode,
					invitation_code: this.payInfo.invitationCode
				}).then((res) => {

					this.pay_price = res.data.pay_price
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 优惠券
			couponChange(e) {
				console.log(e);
				this.payInfo.couponCode = e
				this.calculateAmount()
			},
			// 邀请码
			inviteCodeChange(e) {
				this.payInfo.invitationCode = e
				this.calculateAmount()
			},
			// 下一步
			nextPay() {
				if (this.payMethod == 5) {
					// 线下支付
					console.log("线下支付");
					this.$api.pay({
						payment: "pc",
						pay_order_id: this.orderInfo.pay_order_id,
						payment_type: this.payMethod,
						is_pay_money: this.isBalance,
						coupon: this.payInfo.couponCode,
						invitation_code: this.payInfo.invitationCode
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})

						this.payVisible = false;


						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {

					if (this.isBalance == 1 && this.pay_price == 0) {
						this.$api.pay({
							payment: "pc",
							pay_order_id: this.orderInfo.pay_order_id,
							payment_type: this.payMethod,
							is_pay_money: this.isBalance,
							coupon: this.payInfo.couponCode,
							invitation_code: this.payInfo.invitationCode
						}).then((res) => {
							console.log(res);
							this.$message({
								message: this.langInfo['Payment successful'],
								type: 'success'
							})


							setTimeout(() => {
								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
							}, 800)

							this.payVisible = false
						}).catch((error) => {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
							this.payVisible = false
						})
					} else {
						if (this.payMethod == 1) {
							this.$api.pay({
								payment: "pc",
								pay_order_id: this.orderInfo.pay_order_id,
								payment_type: this.payMethod,
								is_pay_money: this.isBalance,
								coupon: this.payInfo.couponCode,
								invitation_code: this.payInfo.invitationCode
							}).then((res) => {

								this.qrcode = res.data.qrcode
								this.wxPay = true

								this.jieguo = setInterval(() => {
									this.getOrderDetail()
								}, 2000)


								this.payVisible = false
							}).catch((error) => {
								this.payVisible = false
							})

						} else {
							console.log("this.payMethod====" + this.payMethod);
							console.log("this.is_pay_money====" + this.isBalance);

							this.isAlipay = true

							let payLocation =
								'https://app.51exampass.comapi/v1.pay/pay?server=1&payment=pc&pay_order_id=' + this
								.orderInfo.pay_order_id + '&payment_type=' + this.payMethod + '&is_pay_money=' + this
								.isBalance +
								'&coupon=' +
								this.payInfo.couponCode + '&invitation_code=' + this.payInfo.invitationCode +
								'&user_token=' +
								localStorage.getItem('token')

							window.open(payLocation, '_blank')


							this.jieguo = setInterval(() => {
								this.getOrderDetail()
							}, 2000)


							// this.payInfo = {
							// 	remarks: '', //备注，
							// 	couponCode: '', //优惠券码
							// 	invitationCode: '', //邀请码
							// 	pay_money: '' //余额抵扣
							// }
							// this.payVisible = false
						}
					}
				}
			},

			getOrderDetail() {
				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status == 1) {
						// 已支付
						this.order_id = ""
						this.wxPay = false
						clearInterval(this.jieguo)
						this.jieguo = null

						this.$message({
							message: this.langInfo['Payment successful'],
							type: 'success'
						})

						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 900)

					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			closeWxDialog() {
				clearInterval(this.jieguo)
				this.jieguo = null

				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status != 1) {
						// 已支付
						this.order_id = ""
						this.wxPay = false
						this.qrcode = ''
						this.$message({
							message: this.langInfo['Payment failed'],
							type: 'success'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},
			// 分享到qq
			shareQQ() {

				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(this.productDetail.name);
				const desc = encodeURIComponent(this.productDetail.name);
				const summary = encodeURIComponent(this.productDetail.name);
				const pics = encodeURIComponent(this.productDetail.cover_img);

				window.open(
					`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&pics=${pics}`,
					'_blank');
			},
			// 分享到微博
			shareWB() {
				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(`${this.productDetail.name}`);
				window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`, '_blank');
			},


			copyClick() {
				const textArea = document.createElement('textarea');
				textArea.value = window.location.href;
				textArea.style.position = 'fixed'; // 避免可见区域闪烁
				document.body.appendChild(textArea);
				textArea.select();
				// 尝试复制并处理可能的异常
				const success = document.execCommand('copy');
				document.body.removeChild(textArea);
				if (success) {
					this.$message.success(this.langInfo['Copy successfully']);
				} else {
					this.$message.success("复制方法失败");
				}
			}
		}
	}
</script>

<style scoped>
	.formInput {
		border: none;
		background-color: transparent;
	}

	.formInput::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	.courseInfo {
		background-image: url('../../static/image/index05.png');
		background-size: 100% 230px;
		background-repeat: no-repeat;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 38px;
		height: 4px;
		background-color: #FF0000;
		bottom: -16px;
		left: 50%;
		transform: translateX(-50%);

	}

	/deep/.el-dialog--center {
		background-color: #F9F9F9;
	}

	/deep/.el-input__inner {
		border: 0;
	}

	/deep/.el-input__inner::placeholder {
		color: #b8b8b8;
	}
</style>